import { useTransition, animated } from "@react-spring/web";

import Loading from "./Loading";
import { useMinDurationLoading } from "../../../hooks/use-min-duration-loading";

export default function FullScreenLoading({
  loadingTrigger,
  loadingText = "Loading...",
}) {
  const shouldRender = useMinDurationLoading(loadingTrigger);

  const fadeLoadingAnim = useTransition(shouldRender, {
    from: { opacity: 1, zIndex: 20 },
    enter: { opacity: 1, zIndex: 20 },
    leave: { opacity: 0, zIndex: 20 },
    config: { friction: 20 },
  });

  return fadeLoadingAnim(
    (styles, item) =>
      item && (
        <animated.div
          style={styles}
          className="fixed inset-0 transition-opacity"
        >
          <div className="absolute inset-0 bg-primary"></div>
          <div className="flex items-center min-h-screen justify-center">
            <div className="relative inline-block my-4 align-middle max-w-2xl w-full">
              <Loading shouldShow />
              <h4 className="text-center text-secondary mt-4">
                {loadingText}
              </h4>
            </div>
          </div>
        </animated.div>
      ),
  );
}
